import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';
import { AccordionWidowhood } from 'shell/components/shared/sipo-person-form/new-person';

export const transformWidowhood = (person: SubjectData): AccordionWidowhood | undefined => {
  const eventChoiceDate = transformToChoiceDate(
    person.vedovanza?.datiMorteconiuge?.senzaGiorno,
    person.vedovanza?.datiMorteconiuge?.senzaGiornoMese
  );

  const originReturnData: AccordionWidowhood | undefined = person.vedovanza
    ? {
        number: person.vedovanza?.ordineMatrimonioPrecedente
          ? Number.parseInt(person.vedovanza?.ordineMatrimonioPrecedente, 10)
          : 0,
        italian: {
          location:
            person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.descrizioneLocalita || '',
          // municipality: person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.nomeComune || '',
          municipality: person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.codiceIstat
            ? {
                id: person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.codiceIstat || '',
                description:
                  person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.nomeComune || '',
                province:
                  person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.siglaProvinciaIstat ||
                  '',
              }
            : null,
          province:
            person.vedovanza?.datiMorteconiuge?.luogoEvento?.comune?.siglaProvinciaIstat || '',
        },
        foreign: {
          municipality: person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita
            ?.descrizioneLocalita
            ? {
                description:
                  person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita?.descrizioneLocalita ||
                  '',
                province:
                  person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita?.provinciaContea || '',
              }
            : null,
          province:
            person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita?.provinciaContea || '',
          state: {
            id: person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita?.codiceStato || '',
            value:
              person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita?.descrizioneStato || '',
          },
        },
        isForeign: !!person.vedovanza?.datiMorteconiuge?.luogoEvento?.localita,
        eventDate: person.vedovanza?.datiMorteconiuge?.dataEvento
          ? DateTime.fromISO(person.vedovanza?.datiMorteconiuge?.dataEvento)
          : null,
        eventChoiceDate,
        exceptionalLocation:
          person.vedovanza?.datiMorteconiuge?.luogoEvento?.luogoEccezionale || '',
        // paper
        municipality: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.comuneRegistrazione
          ?.codiceIstat
          ? {
              id:
                person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.codiceIstat || '',
              description:
                person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.nomeComune || '',
              province:
                person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.comuneRegistrazione
                  ?.siglaProvinciaIstat || '',
            }
          : null,
        year: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.anno || '',
        province:
          person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.comuneRegistrazione
            ?.siglaProvinciaIstat || '',
        documentNumber: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.numeroAtto || '',
        portion: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.parte || '',
        range: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.serie || '',
        regVol: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.volume || '',
        office: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.ufficioMunicipio || '',
        documentDate: person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.dataFormazioneAtto
          ? DateTime.fromISO(
              person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.dataFormazioneAtto
            )
          : null,
        transcript:
          person.vedovanza?.datiMorteconiuge?.attoEventoANPR?.atto?.trascritto === '1'
            ? true
            : false,
      }
    : undefined;

  return originReturnData;
};
